import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54b772a8")

_pushScopeId("data-v-54b772a8")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "nav__title" }, "Transferência", -1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_OCalendar = _resolveComponent("OCalendar")
  const _component_FormField = _resolveComponent("FormField")
  const _component_SelectFish = _resolveComponent("SelectFish")
  const _component_SelectPond = _resolveComponent("SelectPond")
  const _component_OInputNumber = _resolveComponent("OInputNumber")
  const _component_OTextarea = _resolveComponent("OTextarea")
  const _component_OButton = _resolveComponent("OButton")
  const _component_BlockUI = _resolveComponent("BlockUI")
  const _directive_focus = _resolveDirective("focus")

  return (_openBlock(), _createBlock(_component_BlockUI, { blocked: _ctx.busy }, {
    default: _withId(() => [
      _createVNode(_component_NavBar, { navigation: "back" }, {
        body: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_FormField, {
            label: "Data",
            invalid: _ctx.v$.form.datetime.$invalid && _ctx.submitted,
            "invalid-message": "Data inválida."
          }, {
            default: _withId(() => [
              _createVNode(_component_OCalendar, {
                modelValue: _ctx.form.datetime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.datetime = $event)),
                class: { 'p-invalid': _ctx.v$.form.datetime.$invalid && _ctx.submitted },
                "show-icon": "",
                placeholder: "Data",
                "touch-u-i": ""
              }, null, 8, ["modelValue", "class"])
            ]),
            _: 1
          }, 8, ["invalid"]),
          _createVNode(_component_FormField, {
            label: "Peixe",
            invalid: _ctx.v$.form.fish.$invalid && _ctx.submitted,
            "invalid-message": "Peixe inválido."
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectFish, {
                modelValue: _ctx.form.fish,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.fish = $event)),
                class: { 'p-invalid': _ctx.v$.form.fish.$invalid && _ctx.submitted }
              }, null, 8, ["modelValue", "class"])
            ]),
            _: 1
          }, 8, ["invalid"]),
          _createVNode(_component_FormField, {
            label: "Açude origem",
            invalid: _ctx.v$.form.pondOrigin.$invalid && _ctx.submitted,
            "invalid-message": "Açude origem inválido."
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectPond, {
                modelValue: _ctx.form.pondOrigin,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.pondOrigin = $event)),
                placeholder: "Açude origem",
                class: { 'p-invalid': _ctx.v$.form.pondOrigin.$invalid && _ctx.submitted }
              }, null, 8, ["modelValue", "class"])
            ]),
            _: 1
          }, 8, ["invalid"]),
          _createVNode(_component_FormField, {
            label: "Açude destino",
            invalid: _ctx.v$.form.pondDest.$invalid && _ctx.submitted,
            "invalid-message": "Açude destino inválido."
          }, {
            default: _withId(() => [
              _withDirectives(_createVNode(_component_SelectPond, {
                modelValue: _ctx.form.pondDest,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.pondDest = $event)),
                placeholder: "Açude destino",
                class: { 'p-invalid': _ctx.v$.form.pondDest.$invalid && _ctx.submitted }
              }, null, 8, ["modelValue", "class"]), [
                [_directive_focus]
              ])
            ]),
            _: 1
          }, 8, ["invalid"]),
          _createVNode(_component_FormField, {
            label: "Quantidade",
            invalid: _ctx.v$.form.quantity.$invalid && _ctx.submitted,
            "invalid-message": "Quantidade inválida."
          }, {
            default: _withId(() => [
              _createVNode(_component_OInputNumber, {
                modelValue: _ctx.form.quantity,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.quantity = $event)),
                locale: "pt-BR",
                inputmode: "numeric",
                placeholder: "Quantidade",
                class: { 'p-invalid': _ctx.v$.form.quantity.$invalid && _ctx.submitted }
              }, null, 8, ["modelValue", "class"])
            ]),
            _: 1
          }, 8, ["invalid"]),
          _createVNode(_component_FormField, { label: "Observações" }, {
            default: _withId(() => [
              _createVNode(_component_OTextarea, {
                modelValue: _ctx.form.notes,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.notes = $event)),
                "auto-resize": "",
                placeholder: "Observações"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_OButton, {
            class: "p-button-primary",
            "icon-pos": "right",
            label: "CRIAR TRANSFERÊNCIA",
            loading: _ctx.creating,
            onClick: _ctx.handleSave
          }, null, 8, ["loading", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["blocked"]))
})